jQuery(document).ready(function($){
	$('#shop_filters .widgettitle').click(function(){
		var elem = $(this);
		var wrapper = $(this).next('.list_wrap');

		if( elem.hasClass('open') ){
			elem.removeClass('open');
			wrapper.css('max-height', '');
		}else{
			$(this).addClass('open');
			var list_height = wrapper.find('ul').innerHeight();
			wrapper.css('max-height', list_height);
		}
	});
});